import { getProductBundledInfo, shopifyCartAdd } from "@utils/api.js";

document.addEventListener('DOMContentLoaded', function () {
  if(!customElements.get('v5-pdp-bundled-sale')) {
    customElements.define('v5-pdp-bundled-sale', class V5PdpBundledSale extends HTMLElement {
      constructor() {
        super();
        this.isMobile = window.innerWidth < 1024;
        this.sectionTitle = this.getAttribute('data-section-title') || ''
        this.variantId = this.getAttribute('data-variant-id') || '';
      }
      connectedCallback() {
        this.innerHTML = this.renderSkeleton();
        this.init();

        // 新 main-product 触发variant变化 - 改变当前变体
        if (document.querySelector('variant-fields')) {
          document.addEventListener('variantChangeEvent', e => {
            const currentVariant = e.detail.variant
            if (currentVariant) {
              this.variantId = currentVariant.id
              this.innerHTML = this.renderSkeleton();
              this.init()
            }
          })
        }
      }
      disconnectedCallback() {
        this.swiper?.destroy()
        this.swiper = null
      }
      async init() {
        try {
          const { data } = await getProductBundledInfo({ skuId: this.variantId, skuId: this.variantId, page: 1, limit: 1000, });
          if (data?.total > 0) {
            const { bundleGoodsList = [], } = data

            this.innerHTML = this.renderDOM(bundleGoodsList);
            this.parentElement.style.display = 'block'

            this.initSwiper(bundleGoodsList);
            this.initEvent();
          } else {
            // 清空DOM
            this.innerHTML = ''
            this.parentElement.style.display = 'none'
          }
        } catch(err) {
          console.error(err)
          this.innerHTML = ''
          this.parentElement.style.display = 'none'
        }
      }
      // 渲染骨架屏
      renderSkeleton() {
        return `
          <div class="flex flex-col gap-y-4 lg:gap-y-8">
            ${this.sectionTitle
              ? `<h2 class="font-semibold w-full px-4 lg:px-0 lg:w-[68.125rem] mx-auto text-center text-[1.75rem] mb-10 lg:text-5xl text-[#242F20] lg:mb-16">${this.sectionTitle}</h2>`
              : ''
            }
            <ul class="w-full flex gap-x-5 lg:gap-x-6 overflow-hidden">
              ${this.renderItemSkeleton()}
            </ul>
          </div>
        `
      }
      renderItemSkeleton() {
        let html = '';
        html = Array.from({ length: 4 }, () => (`
          <li class="flex-shrink-0 w-[17.5rem] lg:w-[19.5rem] overflow-hidden flex flex-col gap-y-4">
            <div class="w-[17.5rem] h-[17.5rem] lg:w-[19.5rem] lg:h-[14.625rem] bg-[#EEE] skeleton"></div>
            <div class="flex flex-col w-full items-start">
              <div class="flex flex-col w-full h-[3rem] lg:h-[3.5rem] gap-y-1">
                <p class="w-full h-5 bg-[#EEE] lg:h-6 skeleton"></p>
                <p class="w-3/5 h-5 bg-[#EEE] lg:h-6 skeleton"></p>
              </div>
              <p class="w-full flex flex-col justify-start gap-y-1 mt-3 h-10">
                <span class="block w-[90%] h-3 lg:h-4 bg-[#EEE] skeleton"></span>
                <span class="block w-[70%] h-3 lg:h-4 bg-[#EEE] skeleton"></span>
              </p>
              <div class="flex items-center justify-between w-full mt-4">
                <div class="w-1/2 h-6 bg-[#EEE] skeleton"></div>
                <div class="w-7 h-7 lg:w-8 lg:h-8 bg-[#EEE] skeleton"></div>
              </div>
            </div>
          </li>
        `)).join('')

        return html
      }
      // 渲染 DOM
      renderDOM(bundleGoodsList) {
        return `
          <div class="flex flex-col">
            ${this.sectionTitle
              ? `<h2 class="font-semibold w-full px-4 lg:px-0 lg:w-[68.125rem] mx-auto text-center text-[1.75rem] mb-10 lg:text-5xl text-[#242F20] lg:mb-16">${this.sectionTitle}</h2>`
              : ''
            }
            <!-- Swiper -->
            <div class="swiper w-full px-4 lg:px-0 relative">
              <div class="swiper-wrapper">
                ${this.renderSlides(bundleGoodsList)}
              </div>
              <div class="w-full h-1 flex items-center justify-center gap-x-1 !bottom-0 lg:hidden swiper-pagination swiper-app-recommend-products-pagination"></div>
            </div>
            ${bundleGoodsList.length > 4
              ? `
                <div class="hidden lg:flex items-center justify-center lg:gap-x-6 lg:mt-8">
                  <div class="v5-pdp-bundled-sale-swiper-button-prev cursor-pointer">
                    <svg class="v5-icon-left-arrow text-[#242F20] lg:w-10 lg:h-10" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect class="icon-bg" x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" fill-opacity="0.5"/>
                      <rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="black" />
                      <g clip-path="url(#v5-icon-left-arrow-clip)">
                        <path d="M28.5 20.25H16.2578" stroke="#242F20" stroke-width="1.6" />
                        <path d="M19.0078 14L12.7581 20.2498L19.0078 26.4995" stroke="#242F20" stroke-width="1.6" />
                      </g>
                      <defs>
                        <clipPath id="v5-icon-left-arrow-clip">
                          <rect width="17" height="16" fill="white" transform="matrix(-1 0 0 1 28.5 12)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="v5-pdp-bundled-sale-swiper-button-next cursor-pointer">
                    <svg class="v5-icon-right-arrow text-[#242F20] lg:w-10 lg:h-10" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect class="icon-bg" x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" fill-opacity="0.5"/>
                      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black"/>
                      <g clip-path="url(#v5-icon-right-arrow-clip)">
                        <path d="M11.5 20.25H23.7422" stroke="#242F20" stroke-width="1.6"/>
                        <path d="M20.9922 14L27.2419 20.2498L20.9922 26.4995" stroke="#242F20" stroke-width="1.6"/>
                      </g>
                      <defs>
                      <clipPath id="v5-icon-right-arrow-clip">
                        <rect width="17" height="16" fill="white" transform="translate(11.5 12)"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>`
              : ''
            }
          </div>
        `
      }
      renderSlides(bundleGoodsList) {
        const isAllDescEmpty = bundleGoodsList.every(item => !item.positioningDesc)

        let html = '';
        bundleGoodsList.forEach(({ url, skuId, title, price, originPrice, positioningDesc, positioningDescColor, image, stock, }, index) => {
          const formatPrice = formatMoney(price * 100, window?.pageInfo?.currency?.money_format)
          const quantityInputHTML = this.renderQuantityInput(stock, skuId, title, formatPrice)

          const imageSrc = image.includes('?') ? image + '&width=624' : item.image + '?width=624'
          html += `
            <div class="swiper-slide w-[17.5rem] lg:w-[19.5rem] overflow-hidden flex flex-col gap-y-4" data-title="${title}">
              <a href="${url}?variant=${skuId}&bundled_action_tag=bundled_sale">
                <img class="w-full h-[17.5rem] lg:h-[14.625rem] bg-white object-contain" src="${imageSrc}" loading="lazy" />
              </a>
              <div class="flex flex-col w-full items-start">
                <a
                  href="${url}?variant=${skuId}&bundled_action_tag=bundled_sale"
                  data-type="text"
                  class="text-base font-semibold text-[#242F20] h-[3rem] lg:text-xl lg:h-[3.5rem] line-clamp-2"
                  title="${title}"
                >${title}</a>
                ${!isAllDescEmpty
                  ? `<p class="text-sm h-10 text-black/65 mt-2 line-clamp-2" style="color:${positioningDescColor}">${positioningDesc}</p>`
                  : ''
                }
                <div class="w-full flex items-center justify-between mt-4">
                  <p class="flex items-center gap-x-2 lg:gap-x-1">
                    <span class="text-base font-semibold lg:text-xl text-[#242F20]">${formatPrice}</span>
                    ${originPrice > price
                      ? `<span class="text-xs lg:text-sm text-black/65 line-through">${formatMoney(originPrice * 100, window?.pageInfo?.currency?.money_format)}</span>`
                      : ''
                    }
                  </p>
                  <div class="flex items-center gap-x-2 lg:gap-x-2" data-action-wrap>
                    ${quantityInputHTML}
                    <button class="jky-v5-button appearance-none bg-primary flex items-center justify-center w-7 h-7 lg:w-8 lg:h-8" data-sku-title="${title}" data-sku-id="${skuId}" data-add-to-cart-btn>
                      <svg class="text-white w-7 h-7 lg:w-8 lg:h-8" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.71484 8.00781H9.65015L11.2313 27.1924H29.5727L34.6183 12.2102H14.3796" stroke="currentColor" stroke-width="2" stroke-linejoin="bevel"/>
                        <path d="M17.0781 18.9531H26.0731" stroke="currentColor" stroke-width="2"/>
                        <path d="M21.5742 23.4453V14.4503" stroke="currentColor" stroke-width="2"/>
                        <path d="M16.5056 30.8516C16.5056 31.9383 15.6247 32.8192 14.538 32.8192C13.4513 32.8192 12.5703 31.9383 12.5703 30.8516" stroke="currentColor" stroke-width="2"/>
                        <path d="M28.2009 30.8516C28.2009 31.9383 27.32 32.8192 26.2333 32.8192C25.1466 32.8192 24.2656 31.9383 24.2656 30.8516" stroke="currentColor" stroke-width="2"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          `
        })

        return html
      }
      // 渲染 quantity-input
      renderQuantityInput(stock, skuId, title, price) {
        return `
          <div class="flex border-solid border-[#E2E3E3] border-[1px]">
            <button
              class="appearance-none bg-[#F5F5F5] flex-center w-7 h-7 lg:w-7 lg:h-7 disabled:opacity-40 disabled:cursor-not-allowed"
              disabled
              data-button-minus
              data-sku-title="${title}"
              data-sku-price="${price}"
            >
              ${this.renderMinusSVG()}
            </button>
            <input
              class="flex-center font-semibold text-center border-0 border-solid border-[#E2E3E3] border-x-[1px] w-8 h-7 lg:w-9 lg:h-7 text-base lg:text-xl"
              type="number"
              value="1"
              readonly
              data-quantity-input
              data-max="${stock}"
              data-sku-id="${skuId}"
              data-sku-title="${title}"
              data-sku-price="${price}"
            />
            <button
              class="appearance-none bg-[#F5F5F5] flex-center w-7 h-7 lg:w-7 lg:h-7 disabled:opacity-40 disabled:cursor-not-allowed"
              data-button-plus
              data-sku-title="${title}"
              data-sku-price="${price}"
            >
              ${this.renderPlusSVG()}
            </button>
          </div>
        `
      }
      renderMinusSVG() {
        return `
          <svg class="text-[#242F20] w-3.5 h-3.5" viewBox="0 0 56 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-1053.000000, -594.000000)">
                <g transform="translate(1053.000000, 594.000000)">
                  <rect x="0" y="0" width="56" height="56"></rect>
                  <g transform="translate(7.000000, 26.000000)" fill="#333" fill-rule="nonzero">
                    <path d="M2.24098777,4.36809816 L39.3054147,4.36809816 C39.7082889,4.36809816 40.0817869,4.27048703 40.4259086,4.07526476 C40.7700303,3.8800425 41.0428097,3.61567902 41.2442468,3.28217432 C41.445684,2.94866961 41.5464025,2.57856074 41.5464025,2.17184769 C41.5464025,1.78140316 41.445684,1.41942855 41.2442468,1.08592384 C41.0428097,0.752419143 40.7700303,0.48805566 40.4259086,0.292833396 C40.0817869,0.0976111321 39.7082889,0 39.3054147,0 L2.24098777,0 C1.83811357,0 1.46881221,0.0976111321 1.1330837,0.292833396 C0.7973552,0.48805566 0.524575789,0.752419143 0.314745474,1.08592384 C0.104915158,1.41942855 0,1.78140316 0,2.17184769 C0,2.57856074 0.104915158,2.94866961 0.314745474,3.28217432 C0.524575789,3.61567902 0.7973552,3.8800425 1.1330837,4.07526476 C1.46881221,4.27048703 1.83811357,4.36809816 2.24098777,4.36809816 Z" id="路径"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        `
      }
      renderPlusSVG() {
        return `
          <svg class="text-[#242F20] w-3.5 h-3.5" viewBox="0 0 56 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-931.000000, -594.000000)">
                <g transform="translate(931.000000, 594.000000)">
                  <rect x="0" y="0" width="56" height="56"></rect>
                  <g transform="translate(7.000000, 7.000000)" fill="#333" fill-rule="nonzero">
                    <path d="M0,20.7484663 C0,21.3688244 0.222420135,21.8969672 0.667260404,22.3328946 C1.11210067,22.768822 1.63667646,22.9867856 2.24098777,22.9867856 L18.5322135,22.9867856 L18.5322135,39.2586131 C18.5322135,39.8622049 18.750437,40.386156 19.1868841,40.8304666 C19.6233311,41.2747772 20.1521035,41.4969325 20.7732013,41.4969325 C21.394299,41.4969325 21.927268,41.2747772 22.3721083,40.8304666 C22.8169485,40.386156 23.0393687,39.8622049 23.0393687,39.2586131 L23.0393687,22.9867856 L39.3054147,22.9867856 C39.909726,22.9867856 40.4343018,22.768822 40.8791421,22.3328946 C41.3239824,21.8969672 41.5464025,21.3688244 41.5464025,20.7484663 C41.5464025,20.1281081 41.3239824,19.5957737 40.8791421,19.1514631 C40.4343018,18.7071525 39.909726,18.4849972 39.3054147,18.4849972 L23.0393687,18.4849972 L23.0393687,2.23831939 C23.0393687,1.63472764 22.8169485,1.11077648 22.3721083,0.666465886 C21.927268,0.222155295 21.394299,0 20.7732013,0 C20.1521035,0 19.6233311,0.222155295 19.1868841,0.666465886 C18.750437,1.11077648 18.5322135,1.63472764 18.5322135,2.23831939 L18.5322135,18.4849972 L2.24098777,18.4849972 C1.63667646,18.4849972 1.11210067,18.7071525 0.667260404,19.1514631 C0.222420135,19.5957737 0,20.1281081 0,20.7484663 Z" id="路径"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        `
      }
      // 初始化 quantity-input 交互事件
      initQuantityEvent(item) {
        const minusBtns = item.querySelectorAll('[data-button-minus]')
        const quantityInputs = item.querySelectorAll('[data-quantity-input]')
        const plusBtns = item.querySelectorAll('[data-button-plus]')

        function handleMinus(e) {
          e.preventDefault()
          const target = e.currentTarget

          quantityInputs.forEach(it => {
            plusBtns.forEach(m => m.removeAttribute('disabled'))
            it.value = it.value * 1 > 1 ? it.value * 1 - 1 : 1

            if (it.value == 1) {
              target.setAttribute('disabled', 'disabled')
            }
          })
        }
        function handlePlus(e) {
          e.preventDefault()
          const target = e.currentTarget

          quantityInputs.forEach(it => {
            minusBtns.forEach(m => m.removeAttribute('disabled'))
            it.value = it.value * 1 < Number(it.dataset.max) ? it.value * 1 + 1 : Number(it.dataset.max)

            if (it.value == Number(it.dataset.max)) {
              target.setAttribute('disabled', 'disabled')
            }
          })
        }

        minusBtns.forEach(it => {
          it.removeEventListener('click', handleMinus)
          // 避免重复注册 click 事件
          if (!it.dataset.hasEvent) {
            it.addEventListener('click', handleMinus)
            it.dataset.hasEvent = true
          }
        })

        plusBtns.forEach(it => {
          it.removeEventListener('click', handlePlus)
          // 避免重复注册 click 事件
          if (!it.dataset.hasEvent) {
            it.addEventListener('click', handlePlus)
            it.dataset.hasEvent = true
          }
        })
      }
      // 初始化 swiper
      initSwiper(bundleGoodsList) {
        this.swiper?.destroy()
        this.swiper = null

        this.swiper = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: 'auto',
          spaceBetween: this.isMobile ? 20 : 24,
          navigation: !this.isMobile && bundleGoodsList.length > 4
            ? {
                prevEl: this.querySelector(".v5-pdp-bundled-sale-swiper-button-prev"),
                nextEl: this.querySelector(".v5-pdp-bundled-sale-swiper-button-next"),
              }
            : false,
        });
      }
      initEvent() {
        this.querySelectorAll('.swiper-slide').forEach(item => {
          // 初始化 quantity-input 交互事件
          this.initQuantityEvent(item)
        })

        // 监听 a 链接，点击事件
        this.querySelectorAll('a').forEach(a => {
          a.addEventListener('click', (e) => {

          })
        })

        // 监听 button 点击事件
        this.querySelectorAll('button[data-add-to-cart-btn]').forEach(button => {
          button.addEventListener('click', async (e) => {
            const target = e.currentTarget
            // loading
            target.classList.add('loading')

            const skuId = target.getAttribute('data-sku-id');

            // 触发添加到购物车的事件
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const quantity = target.parentElement.querySelector('[data-quantity-input]').value
            try {
              const data = await shopifyCartAdd({ items: [{ id: Number(skuId), quantity, properties: { Action: 'bundled sale' } }] });
              if(cart) {
                cart.renderContents(data)
              } else {
                window.location.href = '/cart'
              }
            } catch(err) {
              console.error(err)
            } finally {
              // 移除loading
              target.classList.remove('loading')

              // 数据埋码
              gaPushDataLayer('5.0_products_details_page_user_clicks', {
                product_spu_name: this.getAttribute('data-product-title'), //识别页面产品spu标题名称text
                module: "Product Adds",//固定模块命名Product Adds
                position: target.getAttribute('data-sku-title'), //选择的主体产品sku文本text
                button_name: "AddToCart", // 固定为AddToCart
                quantity: quantity, //识别主体产品加购数量
              })
            }
          })
        })
      }
    })
  }
})
